import React, { Fragment } from 'react';
import { Progress } from 'reactstrap';
import { CircularProgressbar,CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../../assets/css/loading.css'

const Confirmar = ({upload}) => {

    return (
        <Fragment>
            <div className="card-body progress-showcase">
                <div className="col-12 text-center">
                    <h5 className="mb-4"><strong>Estamos {upload==100 ? 'procesando' : 'subiendo'} la información, por favor espere!</strong></h5>
                </div>
				<div className="row d-flex justify-content-center">
                    <div className="col-sm-4">
                        <CircularProgressbarWithChildren 
                            //style={{fontSize:'10px'}}
                            value={upload} 
                            //text={`Upload \n${upload}%`} 
                        >
                            <div className="text-center" style={{ fontSize: 40 }}>
                                <strong>{upload}%</strong><br/>
                                <strong>Cargando</strong>
                                {
                               /*      upload==100 &&
                                    <div className="col-12 text-center d-flex justify-content-center">
                                        <div className="loader-box text-center" style={{height:'80px'}}><span className="rotate solid colored"></span></div>
                                    </div>  */
                                }
                            </div>
                        </CircularProgressbarWithChildren>
                    </div>
				</div>                
			</div>
        </Fragment>
    );
}
 
export default Confirmar;